import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  console.log(params);
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/activos?populate=*`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function listCode(params) {
  console.log(params);
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/activos?populate=deep,4`, options)
    .then((response) => {
      return {
        listCode: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/activos/${id}?populate=deep,3`, options)
    .then((response) => {
      let tag = jsona.deserialize(response.data);
      delete tag.links;
      return tag;
    });
}

function getDetails(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  // Apuntando al nuevo endpoint personalizado
  return axios.get(`${url}/activos/${id}/details`, options).then((response) => {
    const activo = response.data;
    
    // El endpoint devuelve datos en formato Strapi directo
    // Necesitamos normalizar la estructura para que sea compatible
    // especialmente para modelo.subtipo.checklists
    
    if (activo && activo.modelo && activo.modelo.subtipo) {
      const subtipo = activo.modelo.subtipo;
      
      // Normalizar checklists si existen
      if (subtipo.checklists) {
        // Si checklists es un array, asegurarnos de que cada item tenga la estructura correcta
        if (Array.isArray(subtipo.checklists)) {
          subtipo.checklists = subtipo.checklists.map(checklist => {
            // Si el checklist ya tiene la estructura correcta, devolverlo tal cual
            if (checklist.id && checklist.pregunta) {
              return checklist;
            }
            // Si viene en formato diferente, normalizarlo
            return checklist;
          });
        }
      }
    }
    
    return activo;
  });
}

function add(activo) {
  console.log(activo);
  var payload = { data: activo };

  console.log(payload);

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/activos`, payload, options).then((response) => {
    return jsona.deserialize(response.data);
  });
}

function update(activo) {
  console.log(activo);
  var payload = { data: activo };

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .put(`${url}/activos/${activo.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/activos/${id}`, options);
}

export default {
  list,
  listCode,
  get,
  getDetails,
  add,
  update,
  destroy,
};
